import React from 'react';
import { BAND_TOP } from './tokens';
import { useSoft } from './SurfaceStyleContext';

/**
 * Full-bleed status band — only on states that need shouting (funding, sold out, ended,
 * you're in, requested). Sticky under the TopBar on desktop. Backgrounds: funding magenta /
 * black, sold out red / white, ended + ticket-held black / white, requested yellow / black.
 */
export default function StatusBand({ label, value, note, bg = '#000', fg = '#fff', sticky = true, top = BAND_TOP, mobile = false, className = '', testId = 'status-band' }) {
  const soft = useSoft();
  if (soft) {
    // Soft: an inline rounded band in the content column — inverted mini-pill label, 15px/800
    // value, the note right-aligned (dropped on phones, which have no room for it).
    return (
      <div
        className={`flex flex-wrap items-center ${className}`}
        style={{ gap: mobile ? '6px 12px' : '10px 16px', padding: mobile ? '12px 16px' : '14px 20px', borderRadius: mobile ? 18 : 20, background: bg, color: fg }}
        data-testid={testId}
        data-soft="1"
      >
        <span className="rounded-full font-mono font-bold uppercase" style={{ fontSize: 9, letterSpacing: '0.16em', padding: mobile ? 0 : '4px 10px', background: mobile ? 'transparent' : fg, color: mobile ? fg : bg }}>{label}</span>
        <span className="font-mono font-bold" style={{ fontSize: mobile ? 13 : 15, letterSpacing: '0.06em' }}>{value}</span>
        {note && !mobile && <span className="ml-auto font-mono font-bold uppercase" style={{ fontSize: 10, letterSpacing: '0.14em' }}>{note}</span>}
      </div>
    );
  }
  return (
    <div
      className={`border-b-2 border-black ${sticky ? 'sticky z-[35]' : ''} ${className}`}
      style={{ background: bg, color: fg, top: sticky ? top : undefined }}
      data-testid={testId}
    >
      <div className="mx-auto flex items-center gap-5" style={{ maxWidth: 1440, padding: mobile ? '8px 12px' : '10px 32px' }}>
        <span className="font-mono font-bold uppercase" style={{ fontSize: 11, letterSpacing: '0.2em' }}>{label}</span>
        <span className="font-mono font-bold" style={{ fontSize: 13, letterSpacing: '0.1em' }}>{value}</span>
        {note && <span className="ml-auto truncate font-mono uppercase" style={{ fontSize: 10, letterSpacing: '0.1em', opacity: 0.75 }}>{note}</span>}
      </div>
    </div>
  );
}
